import ResponsiveImage from '@limbo-works/vue-responsive-image';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayLikeToArray);

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties$1 = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties$1);

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArrayLimit);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = unwrapExports(slicedToArray);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = unwrapExports(defineProperty);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// NOTE: in order to use the URL API we need to provide a base
var DEFAULT_BASE_URL = 'https://example.com';
var getUmbracoImageUrl = function getUmbracoImageUrl(sourceUrl, width, height) {
  var transformations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return getImageUrl(sourceUrl, _objectSpread({
    width: width,
    height: height,
    mode: 'crop',
    autorotate: true
  }, transformations));
};
var getImageUrl = function getImageUrl(sourceUrl, transformations) {
  var url = new URL(sourceUrl, DEFAULT_BASE_URL);
  Object.entries(transformations).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return url.searchParams.set(name, value);
  });
  return "".concat(url.pathname, "?").concat(url.searchParams.toString());
};
var imageSizes = function imageSizes(_ref3) {
  var defaultSize = _ref3.default,
      sizesByBreakpoint = _objectWithoutProperties(_ref3, ["default"]);

  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var breakpointNames = Object.keys(breakpoints);
  return Object.entries(sizesByBreakpoint).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        breakpointName = _ref5[0];

    return breakpointNames.includes(breakpointName);
  }).reduce(function (sizes, _ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        breakpointName = _ref7[0],
        size = _ref7[1];

    return ["(min-width: ".concat(breakpoints[breakpointName].em, "em) ").concat(size)].concat(_toConsumableArray(sizes));
  }, [defaultSize].filter(Boolean)).join(', ');
};

var FORMATS = {
  webp: 'image/webp'
};
var script = {
  components: {
    ResponsiveImage: ResponsiveImage
  },
  inheritAttrs: false,
  props: {
    sourceUrl: {
      type: String,
      required: true
    },
    sourceWidth: {
      type: Number,
      required: true
    },
    sourceHeight: {
      type: Number,
      required: true
    },
    aspectRatio: {
      type: Number,
      default: function _default() {
        if (this.sourceWidth && this.sourceHeight) {
          return this.sourceWidth / this.sourceHeight;
        }

        throw new Error('Either `aspectRatio` or `sourceWidth` and `sourceHeight` must be set.');
      }
    },
    widths: {
      type: Array,
      required: true
    },
    srcWidth: {
      type: Number,
      default: function _default() {
        return this.widths[0];
      }
    },
    formats: {
      type: Object,
      default: function _default() {
        return FORMATS;
      }
    },
    transformations: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    imageClassNames: [String, Array, Object],
    includeHeightDescriptor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    src: function src() {
      var width = this.srcWidth;
      var height = Math.round(width / this.aspectRatio);
      return this.imageUrl(width, height);
    },
    srcset: function srcset() {
      var _this = this;

      var widths = this.widths;

      if (this.sourceWidth) {
        widths = this.widths.filter(function (width) {
          return width <= _this.sourceWidth;
        });
      }

      return widths.map(function (width) {
        var height = Math.round(width / _this.aspectRatio);

        var source = _this.imageUrl(width, height);

        return {
          source: source,
          width: width,
          height: height
        };
      });
    },
    sources: function sources() {
      var _this2 = this;

      return Object.entries(this.formats).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            format = _ref2[0],
            type = _ref2[1];

        return [].concat(_toConsumableArray(acc), [_defineProperty({
          format: format,
          type: type
        }, _this2.$attrs.lazyload ? 'data-srcset' : 'srcset', _this2.srcset.map(function (_ref3) {
          var source = _ref3.source,
              width = _ref3.width,
              height = _ref3.height;
          return ["".concat(source, "&format=").concat(format), "".concat(width, "w"), _this2.includeHeightDescriptor && "".concat(height, "h")].filter(Boolean).join(' ');
        }).join(', '))]);
      }, []);
    },
    defaultSrcset: function defaultSrcset() {
      var _this3 = this;

      return this.srcset.map(function (_ref5) {
        var source = _ref5.source,
            width = _ref5.width,
            height = _ref5.height;
        return [source, "".concat(width, "w"), _this3.includeHeightDescriptor && "".concat(height, "h")].filter(Boolean).join(' ');
      }).join(', ');
    }
  },
  methods: {
    imageUrl: function imageUrl(width, height) {
      return getUmbracoImageUrl(this.sourceUrl, width, height, this.transformations);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('picture', {
    staticClass: "c-umbraco-image",
    class: {
      'c-umbraco-image--lazyload': _vm.$attrs.lazyload
    }
  }, [_vm._l(_vm.sources, function (ref) {
    var format = ref.format;
    var rest = objectWithoutProperties(ref, ["format"]);
    var source = rest;
    return _c('source', _vm._b({
      key: format,
      attrs: {
        "sizes": _vm.$attrs.sizes
      }
    }, 'source', source, false));
  }), _vm._v(" "), _c('ResponsiveImage', _vm._b({
    staticClass: "c-umbraco-image__image",
    class: _vm.imageClassNames
  }, 'ResponsiveImage', Object.assign({}, _vm.$attrs, {
    src: _vm.src,
    srcset: _vm.defaultSrcset
  }), false))], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;
export { getUmbracoImageUrl, imageSizes };
